import React from "react";
import XIcon from "../../assets/icons/xIcon";

interface KeywordDisplayWithXProps {
    name: string;
    onClose: () => void;
}

export default function KeywordDisplayWithX(props: KeywordDisplayWithXProps) {
    return (
        <div className="keyword-display dark">
            <h4 className="keyword-name">{props.name}</h4>
            <div className="close" onClick={props.onClose}><XIcon/></div>
        </div>
    );
}